import { Modal } from '@teko/ds-desktop';
import { MODE_TERMINAL_PICKER, useDistanceTerminalContext } from 'contexts';
import * as React from 'react';
import { PopupTerminalPickerProps } from '..';
import { ModeEnterAddressV2 } from './ModeEnterAddressV2';
import { ModeListAddress } from './ModeListAddress/ModeListAddress';
import { ModeListTerminal } from './ModeListTerminal';

export const PopupTerminalPickerDesktop: React.FC<
  Omit<PopupTerminalPickerProps, 'isMobile'>
> = ({ onClosePopup, showPopup }) => {
  const { modeTerminalPicker } = useDistanceTerminalContext();

  return (
    <Modal
      visible={showPopup}
      onClose={onClosePopup}
      footer={false}
      showCloseIcon={false}
      width={480}
      contentStyle={{ borderRadius: '24px' }}
    >
      {modeTerminalPicker === MODE_TERMINAL_PICKER.ENTER_ADDRESS && (
        <ModeEnterAddressV2 onClosePopup={onClosePopup} />
      )}
      {modeTerminalPicker === MODE_TERMINAL_PICKER.LIST_TERMINAL && (
        <ModeListTerminal onClosePopup={onClosePopup} />
      )}
      {modeTerminalPicker === MODE_TERMINAL_PICKER.LIST_ADDRESS && (
        <ModeListAddress onClosePopup={onClosePopup} />
      )}
    </Modal>
  );
};
